export default __webpack_public_path__ + "static/media/cont-footer-logo.0835836d.png";